import { render, staticRenderFns } from "./BtnFactura.vue?vue&type=template&id=073ef8ac&"
import script from "./BtnFactura.vue?vue&type=script&lang=js&"
export * from "./BtnFactura.vue?vue&type=script&lang=js&"
import style0 from "./BtnFactura.vue?vue&type=style&index=0&id=073ef8ac&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports